/**
 * Retrieve Wikimedia Tool Schema
 *
 * Download and process specific image from Wikimedia Commons.
 */
import { z } from "zod";
// ═══════════════════════════════════════════════════════════════════════════
// PARAMS SCHEMA
// ═══════════════════════════════════════════════════════════════════════════
/**
 * Retrieve Wikimedia parameters
 */
export const RetrieveWikimediaParamsSchema = z.object({
    uiDescription: z.string()
        .describe("Brief description (max ~15 words) of what this tool call is attempting."),
    fileName: z.string()
        .min(1, "File name is required")
        .describe("Wikimedia file name from search result (e.g., 'Satya_Nadella.jpg')"),
    requirementId: z.string()
        .min(1, "Requirement ID is required")
        .describe("The requirement ID this asset fulfills"),
});
